import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { ArticlePurchaseInformation } from '@work4all/models/lib/Classes/ArticlePurchaseInformation.entity';

import { PositionListPicker } from './PositionListPicker';

const ARTICLE_PURCHASE_INFO = gql`
  query getArticlePurchaseInformation($articleId: Int!) {
    getArticlePurchaseInformation(articleCode: $articleId) {
      price
      objectId: objectCode
      purchaseInfoType
      validFromDate
      purchasePriceDiscount
      purchasePriceListPrice
      supplier {
        id: code
        name
        number: nummer
      }
      currency {
        id: code
        name
      }
      objectDate
      objectNumber
    }
  }
`;

interface ArticlePurchaseInformationResponse {
  getArticlePurchaseInformation: ArticlePurchaseInformation[];
}

interface ArticlePurchaseInformationVariables {
  articleId: number;
}

export type SupplierPricePickerProps = {
  articleId: number;
  value: { name: string };
  onChange: (item: ArticlePurchaseInformation) => void;
  onlySuppliersWithPurchasePrice?: boolean;
};

export const SupplierPricePicker = (props: SupplierPricePickerProps) => {
  const { articleId } = props;

  const variables = useMemo(() => {
    return {
      articleId,
    };
  }, [articleId]);

  const response = useQuery<
    ArticlePurchaseInformationResponse,
    ArticlePurchaseInformationVariables
  >(ARTICLE_PURCHASE_INFO, {
    variables,
  });

  return (
    <PositionListPicker
      data={response.data?.getArticlePurchaseInformation || []}
      articleId={articleId}
      {...props}
    />
  );
};
